import { ActionTree } from 'vuex';
import ApiUrl from '../../../api/url';
import { MailSettingState, MailSetting } from './types';
import { RootState } from '../../types';
import * as types from './mutation-types';
import { isHappenedOtherPartyError } from '../../error-type';
import { translator } from '../../translator';
import { AppContext } from '../../context';
const MessageKey = AppContext.MessageKey;

export const actions: ActionTree<MailSettingState, RootState> = {
    /**
     * メール設定情報取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {string} category 絞り込むカテゴリ名
     * @returns {Promise<void>}
     */
    async show({ dispatch, commit }, category: string = '') {
        const requestParams = category ? { category } : undefined;
        try {
            commit(types.SHOW_START);
            const resData = await dispatch(
                'auth/api',
                { method: 'get', url: ApiUrl.MailSetting.SHOW, params: requestParams },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SHOW_SUCCESS, {
                    authentications: resData.authentications,
                    mailSetting: resData.setting,
                });
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.SHOW_FAILURE, resData.errors[0]);
        }
    },

    /**
     * メール設定情報更新
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} rootState Vuex変数
     * @param {MailSetting} mailSetting 更新するメール設定情報
     * @returns {Promise<void>}
     */
    async update({ dispatch, commit, rootState }, { mailSetting, category }) {
        try {
            commit(types.UPDATE_START, category);
            const resData = await dispatch(
                'auth/api',
                { method: 'put', url: ApiUrl.MailSetting.UPDATE, params: mailSetting },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.UPDATE_SUCCESS);

                // 成功トースト表示
                const i18n = (rootState as any).i18n;
                const message = translator(i18n, MessageKey.MailSetting.UPDATED);
                dispatch('toastMessage', message, { root: true });
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.UPDATE_FAILURE, params);
        }
    },

    /**
     * メール設定情報で接続テスト
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} rootState Vuex変数
     * @param {any} SMTP メール設定情報
     * @returns {Promise<void>}
     */
    async connection({ dispatch, commit, rootState }, { smtp }) {
        try {
            commit(types.CONNECTION_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'post',
                    url: ApiUrl.MailSetting.CONNECTION,
                    params: { SMTP: smtp },
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.CONNECTION_SUCCESS);

                // 成功トースト表示
                const i18n = (rootState as any).i18n;
                const mail_server = translator(i18n, 'SMTP_Server');
                const message = translator(i18n, MessageKey.MailSetting.CONNECTED);
                dispatch('toastMessage', `${mail_server} ${message}`, {
                    root: true,
                });
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.CONNECTION_FAILURE, params);
        }
    },

    /**
     * 画面切り替え時のstoreの消去
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute() {
        /**/
    },
};
